import axios from 'axios'
import {OK} from "../../util";

const actions = {
    // ログイン
    login: async ({commit}, data) => {
        const response = await axios.post('/login', data)
        const user = response.data.data || null

        if (response.status === OK && user !== null) {
            commit('setToken', user.token)
            commit('setUser', user)
            return true
        }
        return false
    },

    // ログインチェック
    loginCheck: async ({commit}) => {
        const response = await axios.get('/loginCheck')
        const result = response.data.result || false
        const user = response.data.data || null

        if (response.status === OK && user !== null) {
            commit('setToken', user.token)
            if (result) {
                commit('setUser', user)
            }
        }
    },

    // ログアウト
    logout: async ({commit}) => {
        await axios.get('/logout')
        commit('setUser', null)
    },
};

export default actions;